import { isEqual } from "lodash"
import React, { useMemo } from "react"

import {
  useSelection,
  useUpdateSelectionConfigEffect,
} from "~shared/components/providers/SelectionProvider"

import { DEFAULT_KEY } from "../../constants"
import { KeyLabels } from "../../container/Menu"
import { InputRow } from "./InputRow"

type SingleSelectRowProps = {
  value: string
  displayKeyValuePairs: KeyLabels
  onChange: (value: keyof KeyLabels) => void

  title?: string
  disabled?: boolean
  defaultOverwrite?: string
}

export function SingleSelectRow({
  title,
  value,
  disabled,
  defaultOverwrite,
  displayKeyValuePairs,
  onChange,
}: SingleSelectRowProps) {
  const { key, selectSingle } = useSelection()

  const items = useMemo(
    () => Object.keys(displayKeyValuePairs),
    [displayKeyValuePairs],
  )
  const config = useMemo(
    () => ({
      key,
      title,
      items,
      displayMapping: (key: keyof KeyLabels) => displayKeyValuePairs[key],
    }),
    [displayKeyValuePairs, items, key, title],
  )
  useUpdateSelectionConfigEffect(config)

  const onPress = () =>
    selectSingle({ ...config, selection: value }).then(onChange)

  return (
    <InputRow
      text={
        displayKeyValuePairs[value] ??
        defaultOverwrite ??
        displayKeyValuePairs[DEFAULT_KEY]
      }
      icon={{ name: "format-list-checkbox" }}
      disabled={disabled ?? isEqual(items, [DEFAULT_KEY])}
      onPress={onPress}
    />
  )
}
